export default {
  'Gérer les congés': 'Demandes',
  'Historique des congés': 'Historique',
  Groupes: 'Groupes',
  Demandes: 'Demandes',
  'Mes congés': 'Mes congés',
  Congés: 'Congés',
  'Congés de mon équipe': 'Congés de mon équipe',
  Ajustements: 'Ajustements',
  'Gestion des congés': 'Gestion des congés',
  COUNTRY_ENTITLEMENTS: {
    TITLE: 'Droits par pays',
    DESCRIPTION: 'Activez les estimations indicatives et adaptez le nombre de jours pour les pays de vos sites.',
    ENABLED: 'Activé',
    DISABLED: 'Désactivé',
    NO_COUNTRIES: 'Aucun pays n’est associé aux sites de votre entreprise.',
    NO_DEFAULTS: 'Aucun droit par défaut n’est configuré pour ce pays.',
    LEAVE_TYPE: 'Type de congé',
    PERIOD: 'Période',
    DEFAULT: 'Estimation par défaut',
    COMPANY_MAXIMUM: 'Valeur entreprise',
    SAVE: 'Enregistrer les valeurs',
    LOAD_ERROR: 'Erreur lors du chargement des droits par pays',
    REQUEST_LOAD_ERROR: 'Erreur lors du chargement des types de congé disponibles',
    SELECT_EMPLOYEE_FIRST: 'Sélectionnez d’abord un collaborateur',
    LOADING_TYPES: 'Chargement des types de congé...',
    NO_AVAILABLE_TYPES: 'Aucun type de congé disponible pour ce pays',
    ACTIVE_COUNTRIES: 'pays actifs sur {{total}}',
    SELECT_COUNTRY: 'Choisir un pays',
    CONFIGURED_TYPES: 'types configurés',
    ACTIVATION_HELP: 'Afficher ces estimations aux collaborateurs',
    DISABLED_TITLE: 'Les estimations sont désactivées pour ce pays',
    DISABLED_HELP: 'Le formulaire de congé conserve son fonctionnement actuel tant que cette option reste désactivée.',
    SEARCH_PLACEHOLDER: 'Rechercher un type de congé',
    RESULTS: 'résultats',
    NO_RESULTS: 'Aucun type de congé ne correspond à cette recherche.',
    INDICATIVE_HELP: 'Ces valeurs sont indicatives, modifiables par votre entreprise et ne bloquent jamais une demande.',
    ACTIVATION_SUCCESS: 'Configuration du pays mise à jour',
    ACTIVATION_ERROR: 'Erreur lors de la mise à jour du pays',
    SAVE_SUCCESS: 'Maximums enregistrés avec succès',
    SAVE_ERROR: 'Erreur lors de l’enregistrement des maximums',
    REQUEST_MAXIMUM: 'Estimation indicative de votre entreprise : {{days}} jours',
    PERIODS: {
      YEAR: 'par an',
      EVENT: 'par événement',
      CONTRACT: 'sur la durée du contrat',
      LIFETIME: 'sur toute la carrière',
    },
  },
  GROUPS: {
    'Nom du groupe': 'Nom du groupe',
    Description: 'Description',
    Site: 'Site',
    Actions: 'Actions',
    'Nouveau groupe de congé': 'Nouveau groupe de congé',
    'Rechercher un groupe': 'Rechercher un groupe',
    'Ajouter des types de congé': 'Ajouter des types de congé',
    'Modifier le groupe de congés': 'Modifier le groupe de congés',
    'Type de congé': 'Type de congé:',
    Solde: 'Solde:',
    'jours par': 'jours par',
    mois: 'mois',
    année: 'année',
    'Date du cycle': 'Début du cycle:',
    'Ajouter un type de congé': 'Ajouter un type de congé',
    'Supprimer le groupe de congés': 'Supprimer le groupe de congés',
    'Êtes-vous sûr de vouloir supprimer ce groupe de congés?':
      'Êtes-vous sûr de vouloir supprimer ce groupe de congés?',
    'Groupe de congés supprimé avec succès': 'Groupe de congés supprimé avec succès',
    'Erreur lors de la suppression du groupe de congés': 'Erreur lors de la suppression du groupe de congés',
    LEAVE_GROUPS_TABLE_EMPTY: 'Créez votre premier groupe de congé en cliquant sur le bouton ci-dessus. 😊',
    VALIDATION: {
      GROUP_NAME: 'Merci de saisir un nom pour le groupe',
      SITE_NAME: 'Merci de sélectionner un site auquel associer le groupe',
      LEAVE_TYPE_MISSING: "Merci d'ajouter au moins un type de congé",
      LEAVE_TYPE_INVALID: 'Merci de vérifier les champs pour les types de congé',
    },
    TOASTR: {
      GROUP_CREATED: 'Groupe de congés créé avec succès',
      ERROR_CREATING_GROUP: 'Erreur lors de la création du groupe de congés',
      GROUP_UPDATED: 'Groupe de congés mis à jour avec succès',
      ERROR_UPDATING_GROUP: 'Erreur lors de la mise à jour du groupe de congés',
    },
    'cumulés mensuellement': 'cumulés mensuellement',
    'acquis en début de cycle': 'acquis en début de cycle',
    'en fin du mois': 'en fin du mois',
    'en fin de cycle': 'en fin de cycle',
    'Acquisition:': 'Acquisition:',
    'de chaque année': 'de chaque année',
    'Le 1er': 'Le 1er',
    'Type de jours': 'Type de jours',
    'Jours ouvrés': 'Jours ouvrés',
    'Jours ouvrables': 'Jours ouvrables',
    'Paramétrer :': 'Paramétrer avec :',
  },
  'Aucune demande de congé trouvée ':
    'Pas encore de demande de congé ? Cliquez sur le bouton ci-dessus pour en créer une facilement. 😊',
  'Aucune demande de congé trouvée (admin)':
    'Pas de demande de congé ? Cliquez sur le bouton ci-dessus pour déclarer une facilement. 😊',
  'Aucune demande de congé trouvée (user)': 'Ce collaborateur n’a aucune demande de congé pour le moment.',
  'Aucune demande de congé trouvée (team)': 'Aucune demande de congé pour cette équipe pour le moment.',
  'Déclarer un congé': 'Déclarer un congé',
  'Demander un congé': 'Demander un congé',
  'Demande effectuée': 'Demande effectuée',
  CANCEL_LEAVE_REQUEST_TITLE: 'Annuler la demande de congé',
  CANCEL_LEAVE_REQUEST_CONFIRMATION: 'Êtes-vous sûr de vouloir annuler cette demande de congé?',
  LEAVE_REQUEST_CANCELLED_SUCCESS: 'Demande de congé annulée avec succès',
  LEAVE_REQUEST_CANCEL_ERROR: "Erreur lors de l'annulation de la demande",
  ERROR_FETCHING_LEAVE_REQUESTS: 'Erreur lors du chargement des demandes de congés',
  "jours à l'avance": "jours à l'avance",
  'jours en retard': 'jours en retard',
  'le jour même': 'le jour même',
  'Demande effectuée le:': 'Demande effectuée le:',
  'Demande approuvée le:': 'Demande approuvée le:',
  'Demande refusée le:': 'Demande refusée le:',
  par: 'par',
  'Voir la pièce jointe': 'Voir la pièce jointe',
  'Détails de la demande de congé': 'Détails de la demande de congé',
  'Approbation de la demande de congé': 'Approbation de la demande de congé',
  'Voir les détails du congé': 'Voir les détails du congé',
  'Ouvrir l’écran de gestion du congé': 'Ouvrir l’écran de gestion du congé',
  days: 'jours',
  'Justificatifs:': 'Justificatifs:',
  "Commentaire d'approbation:": "Commentaire d'approbation:",
  'Ajouter un commentaire': 'Ajouter un commentaire',
  Commentaire: 'Commentaire:',
  'En cours...': 'En cours...',
  Approuver: 'Accepter',
  Refuser: 'Refuser',
  Collaborateur: 'Collaborateur',
  'Type de congé': 'Type de congé',
  'Date de début': 'Date de début',
  'Date de fin': 'Date de fin',
  'Date de demande': 'Date de demande',
  'Total demandé': 'Total demandé',
  Statut: 'Statut',
  Tous: 'Tous',
  'En attente': 'En attente',
  Approuvée: 'Approuvée',
  Refusée: 'Refusée',
  Annulée: 'Annulée',
  Actions: 'Actions',
  'Appliqué pour': 'Appliqué pour',
  Date: 'Date',
  "Date d'ajustement": "Date d'ajustement",
  Valeur: 'Valeur',
  Comptabilisé: 'Comptabilisé',
  'Créer un ajustement': 'Créer un ajustement',
  "Modifier l'ajustement de ": "Modifier l'ajustement de ",
  "Voir l'ajustement de ": 'Ajustement de ',
  "Pas d'ajustements": "Pas encore d'ajustements? Cliquez sur le bouton ci-dessus pour en créer un. 😊",
  "Date d'ajout": "Date d'ajout",
  'Voir le solde de congés': 'Voir le solde de congés',
  'Compteurs de solde de congés': 'Compteurs de solde de congés',
  BALANCE_SUBTITLE: 'Récapitulatif de vos compteurs de congés',
  ADJUSTMENTS: {
    DELETE_CONFIRMATION_TITLE: 'Supprimer l’ajustement',
    DELETE_CONFIRMATION_MESSAGE: 'Êtes-vous sûr de vouloir supprimer cet ajustement?',
    ADJUSTMENT_DELETED_SUCCESSFULLY: 'Ajustement supprimé avec succès',
  },
  Acquis: 'Acquis',
  'Acquis / N-1': 'Acquis / N-1',
  'Pris': 'Pris',
  'Solde Restant': 'Total Solde Restant',
  'En attente de validation': 'En attente de validation',
  'En aquisition': 'En aquisition',
  'En aquisition / N': 'En acquisition / N',
  'Jours fériés non payés': 'Jours fériés non chômés',
  'Ajouter un jour férié': 'Ajouter un jour férié',
  'Date du jour férié': 'Date du jour férié',
  'Site concerné': 'Site concerné',
  'Aucun jour férié trouvé': 'Aucun jour férié non chômé défini. Cliquez sur le bouton ci-dessus pour en ajouter un.',
  'Jour férié ajouté avec succès': 'Jour férié non chômé ajouté avec succès',
  "Erreur lors de l'ajout du jour férié": "Erreur lors de l'ajout du jour férié non chômé",
  'Confirmer la suppression': 'Confirmer la suppression',
  'Voulez-vous vraiment supprimer ce jour férié ?': 'Voulez-vous vraiment supprimer ce jour férié non chômé ?',
  'Jour férié supprimé avec succès': 'Jour férié non chômé supprimé avec succès',
  'Erreur lors de la suppression du jour férié': 'Erreur lors de la suppression du jour férié non chômé',
  CUSTOM_HOLIDAYS: {
    TITLE: 'Jours fériés non chômés',
    ADD_UNPAID_HOLIDAY: 'Ajouter jour férié non chômé',
    ADD_MODAL_TITLE: 'Ajouter des jours fériés non chômés',
    SITE: 'Site concerné',
    SELECT_SITE: 'Sélectionner un site',
    SELECT_HOLIDAYS: 'Sélectionner les jours fériés à ajouter',
    NO_HOLIDAYS_FOUND: 'Aucun jour férié standard trouvé pour ce site',
    SELECT_AT_LEAST_ONE: 'Veuillez sélectionner au moins un jour férié',
    ERROR_LOADING_HOLIDAYS: 'Erreur lors du chargement des jours fériés standards',
    DATE_COLUMN: 'Date du jour férié',
    SITE_COLUMN: 'Site concerné',
    NO_HOLIDAYS: 'Aucun jour férié trouvé',
    DUPLICATE_HOLIDAY: 'Ce jour férié existe déjà pour ce site',
    SUCCESS_ADD: 'Jours fériés non chômés ajoutés avec succès',
    SUCCESS_ADD_SINGLE: 'Jour férié non chômé ajouté avec succès',
    SUCCESS_ADD_MULTIPLE: '{{count}} jours fériés non chômés ajoutés avec succès',
    SKIPPED_SINGLE: 'Jour férié a été ignoré car il existe déjà',
    SKIPPED_MULTIPLE: '{{count}} jours fériés ont été ignorés car ils existent déjà',
    ALL_DUPLICATES: 'Tous les jours fériés sélectionnés existent déjà',
    ERROR_ADD: "Erreur lors de l'ajout des jours fériés non chômés",
    BTN_CANCEL: 'Annuler',
    BTN_SAVE: 'Sauvegarder',
  },
  RELIGIOUS_HOLIDAYS: {
    TITLE: 'Dates religieuses',
    HOLIDAY: 'Fête',
    COUNTRY: 'Pays',
    YEAR: 'Année',
    PREDICTED_DATE: 'Date prévisionnelle',
    OFFICIAL_DATE: 'Date officielle',
    DURATION: 'Durée (jours)',
    STATUS: 'Statut',
    ALL_STATUSES: 'Tous les statuts',
    PREDICTED: 'Prévisionnelle',
    OFFICIAL: 'Officielle',
    CANCELLED: 'Annulée',
    CONFIRM: 'Confirmer',
    CORRECT: 'Corriger',
    CONFIRM_TITLE: 'Confirmer la date religieuse',
    CORRECT_TITLE: 'Corriger la date religieuse',
    DISPLAY_NAME: 'Nom affiché',
    CONFIRMATION_NOTE: 'Commentaire de confirmation',
    NO_DATA: 'Aucune date religieuse trouvée pour ces critères',
    NO_CONFIGURED_COUNTRY: 'Aucune date religieuse configurée pour les pays de votre entreprise',
    LOAD_ERROR: 'Erreur lors du chargement des dates religieuses',
    CONFIRM_SUCCESS: 'Date religieuse confirmée avec succès',
    CONFIRM_ERROR: 'Erreur lors de la confirmation de la date religieuse',
    PREDICTED_HINT: 'Date prévisionnelle, susceptible d’être modifiée',
    PREDICTED_LEGEND: 'Jour férié prévisionnel',
    REMINDER_MESSAGE: 'La date prévisionnelle de « {{holidayName}} » est prévue le {{predictedDate}}. Pensez à la vérifier et à la confirmer.',
    REMINDER_LOAD_ERROR: 'Erreur lors du chargement des rappels de dates religieuses',
  },
  'Ajouter des jours fériés non payés': 'Ajouter des jours fériés non chômés',
  'Sélectionner un site': 'Sélectionner un site',
  'Sélectionner les jours fériés à ajouter': 'Sélectionner les jours fériés à ajouter',
  'Aucun jour férié standard trouvé pour ce site': 'Aucun jour férié standard trouvé pour ce site',
  'Veuillez sélectionner au moins un jour férié': 'Veuillez sélectionner au moins un jour férié',
  Chargement: 'Chargement',
  'Rechercher un site': 'Rechercher un site',
  'Aucun site trouvé': 'Aucun site trouvé',
  'Vue mensuelle': 'Vue mensuelle',
  'Synchronisation paie': 'Synchronisation paie',
  MONTHLY_CALENDAR: {
    TITLE: 'Vue mensuelle des disponibilités',
    PRESENT: 'Présent',
    PENDING: 'Congé en attente',
    VALIDATED: 'Congé validé',
    DAY_OFF: 'Jour férié / Off',
  },
  PAYROLL_SYNC: {
    CURRENT_MONTH: 'Mois courant',
    SEARCH_PLACEHOLDER: 'Rechercher un salarié',
    API_SYNC: 'Synchroniser via API',
    EXCEL_SYNC: 'Synchroniser Excel',
    SAVE_ALL: 'Sauvegarder tout',
    MONTH_END_COUNTERS: 'Compteurs paie en fin de mois',
    SELECT_LEAVE_TYPE: 'Sélectionnez un type de congé pour afficher les compteurs.',
    EMPLOYEE: 'Salarié',
    EARNED_N: 'Acquis N',
    TAKEN_N: 'Pris N',
    BALANCE_N: 'Solde N',
    EARNED_N_MINUS_1: 'Acquis N-1',
    TAKEN_N_MINUS_1: 'Pris N-1',
    BALANCE_N_MINUS_1: 'Solde N-1',
    NO_DATA: 'Aucune donnée trouvée pour cette période.',
    LEAVE_TYPES_ERROR: 'Erreur lors du chargement des types de congé',
    LOAD_ERROR: 'Erreur lors du chargement de l’historique congés paie',
    SAVE_SUCCESS: 'Historique congés paie enregistré avec succès',
    SAVE_ERROR: 'Erreur lors de l’enregistrement de l’historique congés paie',
    DELETE_ROW: 'Supprimer les compteurs',
    DELETE_TITLE: 'Confirmer la suppression',
    DELETE_CONFIRM: 'Supprimer les compteurs paie enregistrés pour ce salarié et cette période ?',
    DELETE_HINT: 'Cette action supprimera uniquement l’historique paie de cette ligne. Le salarié et ses contrats ne seront pas supprimés.',
    DELETE_ACTION: 'Supprimer',
    DELETE_SUCCESS: 'Compteurs paie supprimés avec succès',
    DELETE_ERROR: 'Erreur lors de la suppression des compteurs paie',
    IMPORT: {
      BUTTON: 'Importer un Excel',
      TITLE: 'Importer les compteurs de paie',
      DROP_FILE: 'Déposez votre fichier Excel ici',
      FILE_HELP: 'Formats .xls ou .xlsx, 5 Mo maximum',
      CHOOSE_FILE: 'Choisir un fichier',
      DOWNLOAD_TEMPLATE: 'Télécharger le modèle Excel',
      ANALYZE: 'Analyser le fichier',
      CANCEL: 'Annuler',
      APPLY: 'Appliquer à la table',
      REVALIDATE: 'Revalider les lignes',
      DELETE_ROW: 'Supprimer la ligne',
      EMAIL: 'Email',
      TARGET_MONTH: 'Mois cible',
      TARGET_TYPE: 'Type de congé cible',
      IMPORT_ROWS: 'Lignes à importer',
      ERROR_ROWS: 'Erreurs à corriger',
      TOTAL: 'Total',
      VALID: 'Valides',
      CONFLICTS: 'Conflits',
      ERROR_COUNT: 'Erreurs',
      DELETED: 'Supprimées',
      STATUS: 'Statut',
      STATUS_VALID: 'Valide',
      STATUS_CONFLICT: 'Valeur existante modifiée',
      STATUS_UNCHANGED: 'Sans changement',
      MATRICULE: 'Matricule',
      EXCEL_ROW: 'Ligne Excel {{row}}',
      BLOCKED_UNSAVED: 'Sauvegardez ou abandonnez les changements actuels avant d’importer.',
      APPLIED_TOAST: '{{count}} lignes importées dans la table. Vérifiez les valeurs puis cliquez sur Sauvegarder tout.',
      ERRORS: {
        FILE_REQUIRED: 'Sélectionnez un fichier Excel.',
        FILE_TOO_LARGE: 'Le fichier dépasse la taille maximale de 5 Mo.',
        INVALID_FILE: 'Le fichier est invalide.',
        INVALID_FILE_TYPE: 'Utilisez un fichier .xls ou .xlsx.',
        EMPTY_WORKBOOK: 'Le classeur ne contient aucune feuille.',
        EMPTY_SHEET: 'La feuille ne contient aucune donnée.',
        INVALID_HEADERS: 'Les en-têtes du fichier sont invalides ou incomplets.',
        UNREADABLE_WORKBOOK: 'Le classeur est corrompu, protégé ou illisible.',
        IDENTIFIER_REQUIRED: 'L’email ou le matricule est requis.',
        MATRICULE_REQUIRED: 'Le matricule est requis.',
        UNKNOWN_EMAIL: 'L’email ne correspond à aucun salarié actif.',
        DUPLICATE_EMAIL: 'L’email apparaît plusieurs fois dans le fichier.',
        AMBIGUOUS_EMAIL: 'L’email correspond à plusieurs salariés.',
        UNKNOWN_MATRICULE: 'Le matricule ne correspond à aucun salarié actif.',
        DUPLICATE_MATRICULE: 'Le matricule apparaît plusieurs fois dans le fichier.',
        AMBIGUOUS_MATRICULE: 'Le matricule correspond à plusieurs salariés.',
        NON_NUMERIC_VALUE: 'Le compteur doit être un nombre.',
        TEMPLATE_DOWNLOAD: 'Impossible de télécharger le modèle Excel.',
        SERVER_ERROR: 'Une erreur serveur est survenue.',
      },
    },
  },
}
